/**
 * The address of a list's public page: `/lista/<slug>`, the one the person's ruling of
 * 2026-09-24 settled — the PDP already lives under it (`/lista/<slug>/produto/<itemId>`), so the
 * list and its pieces share one segment.
 *
 * Takes the slug or the list's **id**: the public search returns no slug
 * (`PublicGiftListItemOutput`), and the backend's detail route resolves either one. A page
 * opened by id redirects to its slug, so the address a person copies is always the readable one.
 */
export function publicListHref(idOrSlug: string): string {
  return `/lista/${encodeURIComponent(idOrSlug)}`;
}

const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

/** Whether a value is a backend id (a UUID) — a list named by id and not by slug, or a real list item. */
export function isBackendId(idOrSlug: string): boolean {
  return UUID.test(idOrSlug);
}

/**
 * A piece's page inside a list — the checkout branch's PDP, `/lista/<slug>/produto/<itemId>`,
 * keyed by the **list item** id (not the product's), which is what its backend route reads.
 */
export function publicListPieceHref(slug: string, listItemId: string): string {
  return `/lista/${encodeURIComponent(slug)}/produto/${encodeURIComponent(listItemId)}`;
}
